/* eslint-disable quotes */
export const candlePensIngredientsTranslations = {
  'en-GB': {
    candlePensIngredients: {
      meta: {
        title: 'Candle Pens Set — ingredients & product information',
        description: 'Ingredient composition (INCI/CAS) for Colozoo Candle Pens by colour variant.',
      },
      pageTitle: 'Candle Pens Set — ingredients',
      intro:
        'Composition and product details for the Colozoo Candle Pens set. Ingredient names are listed in English as on the regulatory documentation.',
      productHeading: 'Product',
      productName: 'Product',
      sku: 'SKU',
      ean: 'EAN',
      volume: 'Contents per pen',
      volumeValue: '{{ml}} ml',
      setSize: 'Set',
      setSizeValue: '{{count}} pens',
      warningTitle: 'Important',
      warningBody: 'For adult use only. Keep away from children. This is not a children\'s product.',
      ingredientsHeading: 'Composition by colour',
      ingredientsHint: 'Select a colour to see all ingredients with CAS numbers and approximate weight percentages.',
      tableIngredient: 'Ingredient',
      tableCas: 'CAS No.',
      tablePercent: 'Approx. %',
      inciNote:
        'Chemical and colour-index names are not translated. Percentages are approximate and may vary slightly between production batches.',
      relatedHeading: 'More information',
      relatedCandlePens: 'Tutorials, tips & customer support',
      relatedCandlePensDesc: 'Video instructions and help for your candle pens.',
      relatedCandlePensButton: 'Go to tutorials page',
      relatedCandlePensThumbAlt: 'Candle pens tutorials and support',
      contactHeading: 'Questions about ingredients?',
      contactText: 'If you need clarification, email us at',
      contactAfter: 'and include the colour name from your pen.',
    },
  },
  'en-US': {
    candlePensIngredients: {
      meta: {
        title: 'Candle Pens Set — ingredients & product information',
        description: 'Ingredient composition (INCI/CAS) for Colozoo Candle Pens by color variant.',
      },
      pageTitle: 'Candle Pens Set — ingredients',
      intro:
        'Composition and product details for the Colozoo Candle Pens set. Ingredient names are listed in English as on the regulatory documentation.',
      productHeading: 'Product',
      productName: 'Product',
      sku: 'SKU',
      ean: 'EAN',
      volume: 'Contents per pen',
      volumeValue: '{{ml}} ml',
      setSize: 'Set',
      setSizeValue: '{{count}} pens',
      warningTitle: 'Important',
      warningBody: 'For adult use only. Keep away from children. This is not a children\'s product.',
      ingredientsHeading: 'Composition by color',
      ingredientsHint: 'Select a color to see all ingredients with CAS numbers and approximate weight percentages.',
      tableIngredient: 'Ingredient',
      tableCas: 'CAS No.',
      tablePercent: 'Approx. %',
      inciNote:
        'Chemical and color-index names are not translated. Percentages are approximate and may vary slightly between production batches.',
      relatedHeading: 'More information',
      relatedCandlePens: 'Tutorials, tips & customer support',
      relatedCandlePensDesc: 'Video instructions and help for your candle pens.',
      relatedCandlePensButton: 'Go to tutorials page',
      relatedCandlePensThumbAlt: 'Candle pens tutorials and support',
      contactHeading: 'Questions about ingredients?',
      contactText: 'If you need clarification, email us at',
      contactAfter: 'and include the color name from your pen.',
    },
  },
  de: {
    candlePensIngredients: {
      meta: {
        title: 'Candle Pens Set — Inhaltsstoffe & Produktinformationen',
        description: 'Zusammensetzung (INCI/CAS) der Colozoo Candle Pens nach Farbvariante.',
      },
      pageTitle: 'Candle Pens Set — Inhaltsstoffe',
      intro:
        'Zusammensetzung und Produktdaten zum Colozoo Candle Pens Set. Die Stoffnamen stehen in Englisch wie in der regulatorischen Dokumentation.',
      productHeading: 'Produkt',
      productName: 'Produkt',
      sku: 'SKU',
      ean: 'EAN',
      volume: 'Inhalt pro Stift',
      volumeValue: '{{ml}} ml',
      setSize: 'Set',
      setSizeValue: '{{count}} Stifte',
      warningTitle: 'Wichtig',
      warningBody:
        'Nur für Erwachsene. Von Kindern fernhalten. Dies ist kein Kinderprodukt.',
      ingredientsHeading: 'Zusammensetzung nach Farbe',
      ingredientsHint:
        'Farbe auswählen, um alle Inhaltsstoffe mit CAS-Nummer und ungefährem Gewichtsanteil zu sehen.',
      tableIngredient: 'Inhaltsstoff',
      tableCas: 'CAS-Nr.',
      tablePercent: 'Ca. %',
      inciNote:
        'Chemische und Farbstoff-Bezeichnungen werden nicht übersetzt. Prozentangaben sind Richtwerte und können zwischen Chargen leicht variieren.',
      relatedHeading: 'Weitere Informationen',
      relatedCandlePens: 'Anleitungen, Tipps & Kundenservice',
      relatedCandlePensDesc: 'Video-Anleitungen und Hilfe zu Ihren Candle Pens.',
      relatedCandlePensButton: 'Zur Anleitungsseite',
      relatedCandlePensThumbAlt: 'Candle Pens Anleitungen und Support',
      contactHeading: 'Fragen zu Inhaltsstoffen?',
      contactText: 'Bei Unklarheiten schreiben Sie uns an',
      contactAfter: 'und nennen Sie die Farbbezeichnung auf Ihrem Stift.',
    },
  },
  fr: {
    candlePensIngredients: {
      meta: {
        title: 'Candle Pens Set — ingrédients et informations produit',
        description: 'Composition (INCI/CAS) des Colozoo Candle Pens par couleur.',
      },
      pageTitle: 'Candle Pens Set — ingrédients',
      intro:
        'Composition et informations produit pour le set Colozoo Candle Pens. Les noms des substances sont en anglais, comme sur la documentation réglementaire.',
      productHeading: 'Produit',
      productName: 'Produit',
      sku: 'SKU',
      ean: 'EAN',
      volume: 'Contenu par stylo',
      volumeValue: '{{ml}} ml',
      setSize: 'Set',
      setSizeValue: '{{count}} stylos',
      warningTitle: 'Important',
      warningBody:
        'Réservé aux adultes. Tenir hors de portée des enfants. Ce n\'est pas un produit pour enfants.',
      ingredientsHeading: 'Composition par couleur',
      ingredientsHint:
        'Choisissez une couleur pour voir tous les ingrédients avec numéro CAS et pourcentage en poids approximatif.',
      tableIngredient: 'Ingrédient',
      tableCas: 'N° CAS',
      tablePercent: 'Env. %',
      inciNote:
        'Les noms chimiques et indices colorants ne sont pas traduits. Les pourcentages sont indicatifs et peuvent varier légèrement selon les lots.',
      relatedHeading: 'Plus d\'informations',
      relatedCandlePens: 'Tutoriels, conseils et assistance',
      relatedCandlePensDesc: 'Vidéos et aide pour vos Candle Pens.',
      relatedCandlePensButton: 'Ouvrir la page d’aide',
      relatedCandlePensThumbAlt: 'Tutoriels et assistance Candle Pens',
      contactHeading: 'Questions sur les ingrédients ?',
      contactText: 'Pour toute précision, écrivez-nous à',
      contactAfter: 'en indiquant le nom de la couleur sur votre stylo.',
    },
  },
  it: {
    candlePensIngredients: {
      meta: {
        title: 'Candle Pens Set — ingredienti e informazioni prodotto',
        description: 'Composizione (INCI/CAS) dei Colozoo Candle Pens per variante colore.',
      },
      pageTitle: 'Candle Pens Set — ingredienti',
      intro:
        'Composizione e dati prodotto del set Colozoo Candle Pens. I nomi delle sostanze sono in inglese come nella documentazione normativa.',
      productHeading: 'Prodotto',
      productName: 'Prodotto',
      sku: 'SKU',
      ean: 'EAN',
      volume: 'Contenuto per penna',
      volumeValue: '{{ml}} ml',
      setSize: 'Set',
      setSizeValue: '{{count}} penne',
      warningTitle: 'Importante',
      warningBody:
        'Solo per adulti. Tenere lontano dai bambini. Non è un prodotto per bambini.',
      ingredientsHeading: 'Composizione per colore',
      ingredientsHint:
        'Seleziona un colore per vedere tutti gli ingredienti con numero CAS e percentuale in peso approssimativa.',
      tableIngredient: 'Ingrediente',
      tableCas: 'N. CAS',
      tablePercent: 'Circa %',
      inciNote:
        'I nomi chimici e gli indici coloranti non sono tradotti. Le percentuali sono indicative e possono variare leggermente tra i lotti.',
      relatedHeading: 'Ulteriori informazioni',
      relatedCandlePens: 'Tutorial, consigli e assistenza',
      relatedCandlePensDesc: 'Istruzioni video e supporto per le tue Candle Pens.',
      relatedCandlePensButton: 'Vai alla pagina tutorial',
      relatedCandlePensThumbAlt: 'Tutorial e assistenza Candle Pens',
      contactHeading: 'Domande sugli ingredienti?',
      contactText: 'Per chiarimenti scrivici a',
      contactAfter: 'indicando il nome del colore sulla penna.',
    },
  },
  es: {
    candlePensIngredients: {
      meta: {
        title: 'Candle Pens Set — ingredientes e información del producto',
        description: 'Composición (INCI/CAS) de los Colozoo Candle Pens por color.',
      },
      pageTitle: 'Candle Pens Set — ingredientes',
      intro:
        'Composición e información del set Colozoo Candle Pens. Los nombres de las sustancias están en inglés, como en la documentación regulatoria.',
      productHeading: 'Producto',
      productName: 'Producto',
      sku: 'SKU',
      ean: 'EAN',
      volume: 'Contenido por rotulador',
      volumeValue: '{{ml}} ml',
      setSize: 'Set',
      setSizeValue: '{{count}} rotuladores',
      warningTitle: 'Importante',
      warningBody:
        'Solo para adultos. Mantener fuera del alcance de los niños. No es un producto infantil.',
      ingredientsHeading: 'Composición por color',
      ingredientsHint:
        'Elige un color para ver todos los ingredientes con número CAS y porcentaje en peso aproximado.',
      tableIngredient: 'Ingrediente',
      tableCas: 'N.º CAS',
      tablePercent: 'Aprox. %',
      inciNote:
        'Los nombres químicos e índices de color no se traducen. Los porcentajes son orientativos y pueden variar ligeramente entre lotes.',
      relatedHeading: 'Más información',
      relatedCandlePens: 'Tutoriales, consejos y atención al cliente',
      relatedCandlePensDesc: 'Vídeos e ayuda para tus Candle Pens.',
      relatedCandlePensButton: 'Ir a la página de tutoriales',
      relatedCandlePensThumbAlt: 'Tutoriales y ayuda Candle Pens',
      contactHeading: '¿Preguntas sobre ingredientes?',
      contactText: 'Si necesitas aclaración, escríbenos a',
      contactAfter: 'e indica el nombre del color en tu rotulador.',
    },
  },
}
